import { FC, PropsWithChildren } from 'react';

const FormFooter: FC<PropsWithChildren> = ({ children }) => (
  <div className="cpt-12 pe-3 cpb-12 border-top d-flex justify-content-end align-items-center">
    {children}
  </div>
);

export default FormFooter;
